module.exports = __webpack_public_path__ + "10_mole.586a4bac.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer2/10_mole.png
// module id = C5zI
// module chunks = 0